import { toast } from 'react-toastify';

export const addTransaction = (transaction) => {
  return (dispatch, getState, {
    getFirebase
  }) => {
    const firestore = getFirebase().firestore();
    const uid = getState().firebase.auth.uid; // 🚀 On récupère l'UID de celui qui clique !

    firestore
      .collection('finances')
      .add({
        ...transaction,
        amount: parseFloat(transaction.amount), // Sécurité : force le type Number
        userId: uid, // 🎯 Sauvegarde l'identité du propriétaire de l'opération
        createdAt: new Date()
      })
      .then(() => {
        dispatch({
          type: 'ADD_TRANSACTION',
          transaction
        });
        toast.success("Opération enregistrée !");
      })
      .catch((err) => {
        dispatch({
          type: 'ADD_TRANSACTION_ERR',
          err
        });
        toast.error("❌ Une erreur est survenue lors de l'ajout.");
      });
  };
};

export const deleteTransaction = (id) => {
  return (dispatch, getState, {
    getFirebase
  }) => {
    const firestore = getFirebase().firestore();

    firestore
      .collection('finances')
      .doc(id)
      .delete()
      .then(() => {
        dispatch({
          type: 'DELETE_TRANSACTION'
        });
        toast.success("Opération supprimée !");
      })
      .catch((err) => {
        dispatch({
          type: 'DELETE_TRANSACTION_ERR',
          err
        });
        toast.error("❌ Erreur lors de la suppression.");
      });
  };
};

export const editTransaction = (id, updatedData) => {
  return (dispatch, getState, { getFirebase }) => {
    const firestore = getFirebase().firestore();

    firestore
      .collection('finances')
      .doc(id)
      .update({
        ...updatedData,
        amount: parseFloat(updatedData.amount), // Sécurité type Number
        updatedAt: new Date()
      })
      .then(() => {
        dispatch({
          type: 'EDIT_TRANSACTION_SUCCESS'
        });
        toast.success("Opération modifiée !");
      })
      .catch((err) => {
        dispatch({
          type: 'EDIT_TRANSACTION_ERR',
          err
        });
        toast.error("Erreur lors de la modification.");
      });
  };
};
